import { useState } from "react";
import { PresenceStack } from "@components/avatar/PresenceStack";
import { getPresenceStackOrder } from "@components/avatar/presenceStackOrder";
import {
    presenceScenarioIds,
    presenceScenarios,
    type PresenceScenarioId,
} from "./PresenceStackPlayground.lib";
import {
    BooleanControl,
    PlaygroundSelect,
    VariantGrid,
    VariantItem,
} from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";

/** Design-system playground for a board card's who-is-here avatar stack. */
export const PresenceStackPlayground = () => {
    const [scenarioId, setScenarioId] = useState<PresenceScenarioId>(
        presenceScenarios[0].id,
    );
    const [isAssigneeClickable, setIsAssigneeClickable] = useState(true);
    const [assigneeClickCount, setAssigneeClickCount] = useState(0);
    const members =
        presenceScenarios.find((scenario) => scenario.id === scenarioId)
            ?.members ?? [];
    const { visible, hidden } = getPresenceStackOrder(members);
    const assigneeButtonProps = {
        onClick: () => setAssigneeClickCount((count) => count + 1),
    };

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Scenario</h2>
                        <PlaygroundSelect<PresenceScenarioId>
                            options={presenceScenarioIds}
                            value={scenarioId}
                            onChange={setScenarioId}
                        />
                    </section>
                    <section>
                        <h2>Behavior</h2>
                        <BooleanControl
                            label="Clickable assignee"
                            checked={isAssigneeClickable}
                            onChange={setIsAssigneeClickable}
                        />
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={scenarioId}
                output={JSON.stringify(
                    {
                        visible: visible.length,
                        hidden: hidden.length,
                        assigneeClickCount,
                    },
                    null,
                    2,
                )}
                belowStage={
                    <>
                        <VariantGrid
                            title="Clickable assignee (hover tints it alone)"
                            columns="three"
                        >
                            {presenceScenarios.map((scenario) => (
                                <VariantItem
                                    key={scenario.id}
                                    label={scenario.id}
                                >
                                    <PresenceStack
                                        members={scenario.members}
                                        assigneeButtonProps={
                                            assigneeButtonProps
                                        }
                                    />
                                </VariantItem>
                            ))}
                        </VariantGrid>
                        <VariantGrid title="Read only" columns="three">
                            {presenceScenarios.map((scenario) => (
                                <VariantItem
                                    key={scenario.id}
                                    label={scenario.id}
                                >
                                    <PresenceStack members={scenario.members} />
                                </VariantItem>
                            ))}
                        </VariantGrid>
                    </>
                }
            >
                <PresenceStack
                    members={members}
                    assigneeButtonProps={
                        isAssigneeClickable ? assigneeButtonProps : undefined
                    }
                />
            </ShowcasePreview>
        </SandboxLayout>
    );
};
